// We need jQuery
var $ = window.jQuery;
export default function (){
    const $modal = $('#hub-common-page-modal');
    $('body').on('click','.hub-common-modal-content-btn', function (event) {
        let modalKey, modalContent, modalTitle;
        event.preventDefault();
        modalKey = $(this).attr('data-key');
        modalTitle = $(this).attr('data-modal-title');
        modalContent = $('#' + modalKey).html();
        if(modalKey && modalContent){
            $modal.find('.modal-body').html(modalContent);
            $modal.find('.modal-title').html(modalTitle);
            $modal.modal('show');
        }
    });
}